import { memo } from "react";

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Text,
} from "@chakra-ui/react";

import { FilterElementList } from "../../companiesList/companiesListComponents/tablesTools/innerComponents/filtersBlock/innerComponents/FiltersPanel";

const FilterGroupSection = ({ sectionGroup }) => {
  return (
    <Flex direction={"column"} rowGap={"8px"}>
      <Accordion allowMultiple>
        {sectionGroup?.data?.map((item) => (
          <AccordionItem key={item?.id} border={"none"}>
            <AccordionButton p={"0"} py={"4px"} _hover={{ bg: "transparent" }}>
              <Text fontSize={"14px"} textAlign={"start"}>
                {item?.id}
              </Text>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel p={"0"}>
              <FilterElementList
                {...{ el: item, isBlock: true, maxW: "100%" }}
              />
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Flex>
  );
};

export default memo(FilterGroupSection);
